import React, { createContext, useEffect, useState } from 'react';
import { getIsMobile } from '../utils/helpers';
import { updateApiEndpoint } from '../apiEndpoints';
import { debugLogger } from '../debug/DebugLogger';
import { getLocalStorageKey } from '../hooks/useLocalStorageKey';
import SeptimLoadingSpinner from '../components/Manager/SeptimLoadingSpinner/SeptimLoadingSpinner';

export const ConfigContext = createContext<any>(undefined);

interface ConfigStateProviderProps {
  children: React.ReactNode;
}

const ConfigStateProvider = ({ children }: ConfigStateProviderProps) => {
  const [state, setState] = useState<any>(undefined);

  useEffect(() => {
    const getConfig = async () => {
      const config = await fetch('/config.json').then((response) =>
        response.json()
      );
      const localStorageKey = getLocalStorageKey(config.subUrl);
      const storedUserData = window.localStorage.getItem(localStorageKey);
      let mobileApiEndpoint = '';
      const isMobile = getIsMobile();
      if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        if (userData.apiEndpoint) {
          mobileApiEndpoint = userData.apiEndpoint;
        }
      }
      const apiEndpoint = isMobile ? mobileApiEndpoint : config.apiEndpoint;
      updateApiEndpoint(apiEndpoint);
      debugLogger.configure(config.debug);
      setState(config);
    };
    getConfig();
  }, []);

  return (
    <ConfigContext.Provider value={state}>
      {state ? children : <SeptimLoadingSpinner height="100vh" />}
    </ConfigContext.Provider>
  );
};

export default ConfigStateProvider;
